import { Cache } from "memory-cache";
import { CorporationWalletTransactionEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationWalletTransactionEntity(
  transaction_id: number
): Promise<CorporationWalletTransactionEntity | null> {
  let entity: any = await cache.get(transaction_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationWalletTransactionEntity(transaction: CorporationWalletTransactionEntity) {
  cache.put(transaction.props.transaction_id.toString(), transaction, 60 * 60 * 1000 /* 1 hour */);
}
